import { initializeApp } from 'firebase/app';
import { getAuth, initializeAuth, connectAuthEmulator, onAuthStateChanged, User, browserLocalPersistence, inMemoryPersistence } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCUvVQxNJT3CloKI71-2N3GE6hSFbKjayw',
  authDomain: 'beta.planapus.com',
  projectId: 'planapus-d83dd',
  storageBucket: 'planapus-d83dd.firebasestorage.app',
  messagingSenderId: '637289600486',
  appId: '1:637289600486:web:b9deca6262113acb6d3227',
  measurementId: 'G-56RWZ3MD1Q',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const isDevelopment = window.location.hostname === 'localhost' ||
                      window.location.hostname === '127.0.0.1' ||
                      window.location.hostname === '0.0.0.0';

// Initialize Firebase services.
// In development, use browserLocalPersistence (localStorage) instead of the default
// indexedDB persistence. The Firebase Auth SDK's IndexedDB reads take 20+ seconds
// in the emulator environment, causing a long loading delay on every page load.
export const auth = isDevelopment
  ? initializeAuth(app, { persistence: browserLocalPersistence })
  : getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

if (isDevelopment) {
  // CRITICAL: Set this BEFORE connectAuthEmulator
  auth.settings.appVerificationDisabledForTesting = true;
  console.log('[DEBUG] appVerificationDisabledForTesting set to:', auth.settings.appVerificationDisabledForTesting);
  
  try {
    console.log('[DEBUG] Connecting to Auth Emulator at http://localhost:9099');
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectStorageEmulator(storage, 'localhost', 9199);
    
    console.log('Connected to Firebase emulators');
    
    // Check multiple possible ways the emulator config might be stored
    console.log('[DEBUG] Auth object inspection:', {
      config: (auth as any).config,
      emulatorConfig: (auth as any).emulatorConfig,
      _delegate: (auth as any)._delegate,
      settings: auth.settings
    });
  } catch (error) {
    console.error('Error connecting to emulators:', error);
    console.warn('Emulators already initialized', error);
  }
}

// Timing: track when Firebase is initialized. Dev-only — these timing
// lines leak implementation detail into the production console that
// customers and partners can open (PLN-401).
if (isDevelopment) {
  console.log(`[Firebase] SDK initialized at ${performance.now().toFixed(0)}ms`);
}

// Start listening for auth state immediately at module load time,
// so the auth check begins during bundle execution rather than waiting
// for React to mount AuthProvider.
let _earlyUser: User | null = null;
let _earlyAuthResolved = false;
if (isDevelopment) {
  console.log(`[Firebase] Registering onAuthStateChanged at ${performance.now().toFixed(0)}ms`);
}
const _earlyAuthPromise = new Promise<User | null>((resolve) => {
  const unsub = onAuthStateChanged(auth, (user) => {
    if (isDevelopment) {
      console.log(`[Firebase] onAuthStateChanged fired at ${performance.now().toFixed(0)}ms, user=${user?.email || 'null'}`);
    }
    _earlyUser = user;
    _earlyAuthResolved = true;
    resolve(user);
    unsub();
  });
});

export function getEarlyAuthState(): { user: User | null; resolved: boolean; promise: Promise<User | null> } {
  return { user: _earlyUser, resolved: _earlyAuthResolved, promise: _earlyAuthPromise };
}

export default app;
